// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"c24266d2","outerContainer":"_2e7fb93a","secondaryToolbar":"_936d335e","doorHangerRight":"fa8d68bb","toolbarContainer":"_15040e13","toolbarViewerMiddle":"aef05698","progressBar":"_1c0b1444","back-to-application":"bec7da0d","medicationListWrapper":"ab537628","showDiscontinued":"_7bad36e1","buttonStyles":"acb6a25b","fullWidth":"_60c6b2c5","paginationRoot":"d02b1ef1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/MedicationsList/index.styl
// module id = 5054
// module chunks = 39